import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  selectedItem: null,
  lastAction: '',
};

export const textTestimonialSlice = createSlice({
  name: 'textTestimonialSlice',
  initialState,
  reducers: {
    addTextTestimonial: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    getTextTestimonial: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOneTextTestimonial: (state) => {
      state.loading = true;
      state.error = null;
      state.selectedItem = null;
    },
    successTextTestimonial: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = Array.isArray(action.payload?.data) ? action.payload.data : [];
      state.lastAction = action.payload?.action || '';
    },
    successOneTextTestimonial: (state, action) => {
      state.loading = false;
      state.error = null;
      state.selectedItem = action.payload?.data || null;
      state.lastAction = action.payload?.action || '';
    },
    failedTextTestimonial: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeTextTestimonial: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    updateTextTestimonial: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    clearSelectedTextTestimonial: (state) => {
      state.selectedItem = null;
    },
    clearTextTestimonialStatus: (state) => {
      state.error = null;
      state.lastAction = '';
    },
  },
});

export const {
  addTextTestimonial,
  getTextTestimonial,
  getOneTextTestimonial,
  successTextTestimonial,
  successOneTextTestimonial,
  failedTextTestimonial,
  removeTextTestimonial,
  updateTextTestimonial,
  clearSelectedTextTestimonial,
  clearTextTestimonialStatus,
} = textTestimonialSlice.actions;

export default textTestimonialSlice.reducer;
